import { Button } from "@/components/ui/button";
import { getFullAddress } from "@/helper/format-data";
import { PermitLocation } from "@/types/decree.type";
import useToggle from "hooks/use-toggle";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export type PermitLocationDetailProps = {
  permitLocation: PermitLocation;
  setPermitLocationModalState: () => void;
  removePermitLocation: () => void;
  onClose: () => void;
};
export const PermitLocationDetail = ({
  permitLocation,
  setPermitLocationModalState,
  removePermitLocation,
  onClose,
}: PermitLocationDetailProps) => {
  const [openConfirm, setOpenConfirm] = useToggle(false);

  const handleOpenConfirm = () => {
    setOpenConfirm();
  };

  const handleClose = () => {
    onClose();
  };
  const address = getFullAddress(permitLocation.address);
  return (
    <>
      <div className="transition-opacity absolute h-auto top-22 bg-primary p-3 right-6 mt-4 mb-3 rounded-md shadow-lg z-5 w-80">
        <div>
          <div className="flex justify-between w-full items-center py-2 gap-2">
            <span className="text-sm text-secondary">Decree</span>
            <span className="text-sm text-secondary">{permitLocation.selectedDecrees[0].label}</span>
          </div>
          <div className="flex justify-between w-full items-center py-2 gap-2">
            <span className="text-sm text-secondary">Address</span>
            <span className="text-sm text-secondary">{address}</span>
          </div>
        </div>
        <div className="flex justify-between mt-4">
          <Button onClick={handleOpenConfirm} variant="destructive">
            Delete
          </Button>
          <Button onClick={setPermitLocationModalState} variant="secondary">
            Edit
          </Button>
          <Button onClick={handleClose} variant="secondary">
            Close
          </Button>
        </div>
      </div>
      <AlertDialog open={openConfirm}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Delete a permit location</AlertDialogTitle>
            <AlertDialogDescription>Are you sure that you want to delete this permit location?</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={handleOpenConfirm}>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={removePermitLocation}>Delete</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
